export default __webpack_public_path__ + "static/media/DNo.28-1.a64f5e37.jpg";